// components/preferencias/MetaPixel.tsx
import { useEffect } from 'react'
import { usePreferences } from './PreferencesProvider'
import { isProductionHost } from '../../utils/Env'

const PIXEL_ID = import.meta.env.REACT_APP_META_PIXEL_ID

declare global {
  interface Window {
    fbq?: (...args: unknown[]) => void
    _fbq?: unknown
  }
}

export function MetaPixel() {
  const { preferences } = usePreferences()

  useEffect(() => {
    if (!isProductionHost()) return
    if (!preferences?.marketing) return
    if (!PIXEL_ID) return
    if (window.fbq) return // ya inicializado, evita duplicar

    ;(function (f: any, b: Document, e: string, v: string) {
      if (f.fbq) return
      const n: any = (f.fbq = function (...args: unknown[]) {
        n.callMethod ? n.callMethod.apply(n, args) : n.queue.push(args)
      })
      if (!f._fbq) f._fbq = n
      n.push = n
      n.loaded = true
      n.version = '2.0'
      n.queue = []
      const t = b.createElement(e) as HTMLScriptElement
      t.async = true
      t.src = v
      const s = b.getElementsByTagName(e)[0]
      s.parentNode?.insertBefore(t, s)
    })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js')

    window.fbq!('set', 'autoConfig', false, PIXEL_ID)
    window.fbq!('init', PIXEL_ID)
    window.fbq!('track', 'PageView')
  }, [preferences?.marketing])

  return null
}